import { z } from "zod";

import { attachmentSchema } from "./attachment-schema";
import { isoDate, nullableIsoDate } from "./iso-date-schema";
import { orderDetailSchema } from "./order-schema";
import { userItemSchema } from "./user-item-schema";

// Enum mimics from your schema — adjust as needed
export const visitStatusEnum = z.enum([
  "DRAFT",
  "PENDING",
  "DECLINED",
  "BOOKED",
  "CANCELLED",
  "EXPIRED",
  "COMPLETED",
  "RUNNING",
  "HOLD",
  "REQUESTED",
]);
export const visitTypeEnum = z.enum(["ONSITE", "VIRTUAL"]);

export const visitItemSchema = z.object({
  id: z.string().length(24),
  uuid: z.string(),
  fromDateTime: nullableIsoDate,
  toDateTime: nullableIsoDate,
  serviceId: z.string().nullable(),
  status: visitStatusEnum.nullable(),
  userCreatedId: z.string().nullable(),
  acceptAt: nullableIsoDate,
  cancelAt: nullableIsoDate,
  declineAt: nullableIsoDate,
  arrivalWindow: z.number().nullable(),
  instruction: z.string().nullable(),
  meetLink: z.string().nullable(),
  meetLinkId: z.string().nullable(),
  type: visitTypeEnum.nullable(),
  createdAt: isoDate,
  updatedAt: isoDate,
  isConfirmedRecently: z.boolean().default(false),
  technicians: z.array(userItemSchema).nullish(),
  checkedInTechnicians: z.array(userItemSchema).nullish(),
  order: orderDetailSchema.nullish(),
  attachments: z.array(attachmentSchema).nullish(),
});
